import { ValidationError } from "./api";

/**
 * Populates react form errors from the ValidationError argument using the reactFormsSetError argument.
 * @param validationErrorsInstance - A ValidationError instance.
 * @param reactFormsSetError - A setError function obtained from the useFrom hook.
 */
export function parseValidationErrors(validationErrorsInstance, reactFormsSetError) {
    for (const key of Object.keys(validationErrorsInstance.errors)) {
        const errors = validationErrorsInstance.errors[key];
        if (errors.length > 0) {
            reactFormsSetError(`root.${key}`, {
                type: 'custom',
                message: errors.join(', ')
            });
        }
    }
}

export function createApiOnSubmit(onSubmit, setError) {
    return async (data) => {
        try {
            await onSubmit(data);
        } catch (e) {
            if (e instanceof ValidationError) {
                parseValidationErrors(e, setError);
            } else {
                throw e;
            }
        }
    };
}